export const creditNoteReasonCodesLabels = {
  CREDIT_PURCHASE: 'Credit Purchase',
  ORDER_CANCELLATION: 'Order Cancellation',
  ORDER_CHANGE: 'Order Change',
  OTHER: 'Other',
  PRODUCT_UNSATISFACTORY: 'Product Unsatisfactory',
  SERVICE_UNSATISFACTORY: 'Service Unsatisfactory',
  USAGE_CREDIT: 'Usage Credit',
  WAIVER: 'Waiver',
};
